<div class="df-blocked-property-card">
  <div class="card-header">
    <div class="header-left">
      <img [src]="dfIconUrl" alt="Dwelling Fire icon" class="df-icon" />
      <h3 class="header-title">Dwelling Fire:</h3>
      Binding will be available after {{ propertyProductName }} is issued
    </div>
    <button
      class="collapse-button"
      (click)="toggleCollapse()"
      [attr.aria-label]="isCollapsed ? 'Expand section' : 'Collapse section'"
      >
      <bolt-icon
        [name]="isCollapsed ? 'chevron-down' : 'chevron-up'"
        size="sm"
      ></bolt-icon>
    </button>
  </div>
  @if (!isCollapsed) {
    <div class="card-body">
      <p><strong>Note: </strong> Dwelling fire premium and bind options will be available after the {{ propertyProductName }} policy is active.</p>
      <p><strong>Step 1:</strong> Review, pay, and bind {{ propertyProductName }}.</p>
      <p><strong>Step 2:</strong> After it’s issued, return to dwelling fire to bind.</p>
    </div>
  }
</div>
